// Pathify
import { make } from 'vuex-pathify'
import axios from 'axios'

// Data
const state = {
  drawer: null,
  bundles: {},
  drawerImage: true,
  mini: false,
  universes: [],
  nodes: [],
  events: [],
  searchIndex: null,
  searchResults: [],
  showCpu: true,
  query: '',
  ideStatus: 'deploying',
  notebookStatus: 'deploying',
  loading: true,
  displayFeedback: false,
  feedbackMessage: '',
  feedbackColor: '',
  ticker: {},
  drawerItems: [],
  items: [
    {
      title: 'Dashboard',
      icon: '$vuetify.icons.home',
      to: '/',
    },
    {
      title: 'Nodes',
      icon: '$vuetify.icons.node',
      to: '/ui/nodes/',
    },
    {
      title: 'Events',
      icon: 'mdi-clipboard-text',
      to: '/ui/events/',
    },
  ],
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    //
  },
  search: ({ commit, state }) => {
    if (!state.searchIndex) {
      return state.searchResults
    }

    const searchResults = state.searchIndex.search('*' + state.query + '*')
    const foundUniverses = {}

    for (const [universeName, universe] of Object.entries(state.universes)) {
      const foundApps = []
      for (const app of universe.Apps) {
        for (const result of searchResults) {
          if (result.ref === app.Namespace + '/' + app.Name) {
            foundApps.push(app)
            break
          }
        }
      }
      if (!state.query || foundApps.length) {
        foundUniverses[universeName] = {
          Editable: universe.Editable,
          Apps: foundApps,
        }
      }
    }
    commit('searchResults', foundUniverses)
  },
  loadNodes: async ({ commit }) => {
    const nodesResponse = await axios.get('/api/nodes/')
    const nodes = nodesResponse.data
    commit('nodes', nodes)
  },
  loadUniverses: async ({ commit }) => {
    const universesResponse = await axios.get('/api/universes/')
    const universes = universesResponse.data
    universes.sort((u1, u2) => {
      if (u1.Description === 'Core universe') {
        return -1
      }

      return u1.Name < u2.Name
    })

    commit('universes', universes)
    commit('loading', false)
  },
  loadBundles: async ({ commit }) => {
    const eventResponse = await axios.get('/api/bundles/')
    const bundles = eventResponse.data
    commit('bundles', bundles)
  },
  getIdeStatus: async ({ commit }) => {
    const ideStatusResponse = await axios.get('/api/developer/idestatus')
    const ideStatus = ideStatusResponse.data
    commit('ideStatus', ideStatus.Status)
  },
  getNotebookStatus: async ({ commit }) => {
    const notebookStatusResponse = await axios.get('/api/developer/notebookstatus')
    const notebookStatus = notebookStatusResponse.data
    commit('notebookStatus', notebookStatus.Status)
  },
  startIde: async () => {
    await axios.post('/api/developer/ide')
  },
  startNotebook: async () => {
    await axios.post('/api/developer/notebook')
  },
  stopIde: async () => {
    await axios.delete('/api/developer/ide')
  },
  stopNotebook: async () => {
    await axios.delete('/api/developer/notebook')
  },
  loadEvents: async ({ commit }) => {
    const eventResponse = await axios.get('/api/events/')
    const events = eventResponse.data
    commit('events', events)
  },
  clearTicker: ({ commit, state }) => {
    if (state.ticker) {
      clearInterval(state.ticker)
    }
    commit('ticker', null)
  },
  loadStorages: async ({ commit }, universe) => {
    const response = await axios.get(`/api/universes/get/${universe.name}/storages/`)    
    return response.data
  },
  loadSecrets: async ({ commit }, universe) => {
    const response = await axios.get(`/api/universes/get/${universe.name}/secrets/`)    
    return response.data
  },
  loadStorage: async ({ commit }, storageDef) => {
    const response = await axios.get(`/api/universes/get/${storageDef.universe}/storages/get/${storageDef.name}/`)
    return response.data
  },
}

const getters = {
  universe: state => universeName => {
    const universe = state.universes.find(universe => universe.Name === universeName)
    return universe || {}
  },
  universes: state => {
    if (!state.query) {
      return state.universes
    }

    const found = []
    for (const universe of state.universes) {
      const apps = []
      for (const app of universe.Apps) {
        if (`${universe.Name}/${app.Name}`.match(`.*${state.query}.*`)) {
          apps.push(app)
        }
      }

      if (apps.length) {
        found.push({
          Name: universe.Name,
          Description: universe.Description,
          Editable: universe.Editable,
          Apps: apps,
        })
      }
    }
    return found
  },
  app: state => (universeName, appName) => {
    const universe = state.universes.find(universe => universe.Name === universeName)
    if (!universe) {
      return {}
    }
    const app = universe.Apps.find(app => app.Name === appName)

    return app || {}
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
